import React from 'react'
import PropTypes from 'prop-types'

export default function Header(props) {
  return (
 <nav className="navbar navbar-expand-lg bg-light">
  <div className="container-fluid">
    <a className="navbar-brand" href="#"> {props.title} </a>
  </div>
</nav>

  )

}
Header.defaultProps = {
  title: "your default title",
  // searchBar: true
}

Header.propTypes = {
  title: PropTypes.string,
  searchBar: PropTypes.bool.isRequired
}

// {props.searchBar? <form>.....</form>: "no search bar"}

